import { render, staticRenderFns } from "./SubPrintTeam.vue?vue&type=template&id=0946657f&scoped=true&"
import script from "./SubPrintTeam.vue?vue&type=script&lang=js&"
export * from "./SubPrintTeam.vue?vue&type=script&lang=js&"
import style0 from "./SubPrintTeam.vue?vue&type=style&index=0&id=0946657f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0946657f",
  null
  
)

export default component.exports